module.exports = __webpack_public_path__ + "img/icons B_17.2f57f6c1.svg";